import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import CollapsedMailComponent from '../CollapsedMailComponent.vue'

export const CollapsedMail = Node.create({
  name: 'collapsedMail',
  
  group: 'block',
  
  
  addAttributes() {
    return {
      content: {
        default: '',
        parseHTML: element => element.innerHTML,
      },
    }
  },
  
  parseHTML() {
    return [
      {
        tag: 'collapsed-mail',
        getContent: node => node.innerHTML || '',
      },
    ]
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['collapsed-mail', mergeAttributes(HTMLAttributes)]
  },
  
  addNodeView() {
    return VueNodeViewRenderer(CollapsedMailComponent)
  },
})

export default CollapsedMail 